import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    TextField,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { wrapFormikHandleChange } from "../../../../infrastructure/utils/formatters";
 
import { toast } from "react-toastify";
import * as Yup from "yup";

import DefaultApiService from "../../../../infrastructure/api/default";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import DropdownPicker from "../../../components/shared/dropdown";


const validationSchema = Yup.object().shape({   
  title: Yup.string().required("لطفا این فیلد را پر کنید."),
  description: Yup.string().required("لطفا این فیلد را پر کنید."),
});

const UpdateHistoryModify = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/UM/Yeksa/UpdateHistory");
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const sendData = { ...data, ...formValue };

    try {
      const res = await DefaultApiService.modifyApi(
        "/UM/UpdateHistory",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={roleId !== "create" ? `ویرایش ${data?.updateHistory?.title}` : "ایجاد"}
          />

          <CardContent>
            <Formik
              initialValues={data.updateHistory}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                const onMakeFormikVariable = (name) => ({
                  name: name,
                  fullWidth: true,
                  value: values[name],
                  error: errors[name] && touched[name],
                  helperText: errors[name] && touched[name] && errors[name],
                  variant: "outlined",
                });

                return (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      

                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          label="عنوان"
                          type="string"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("title")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <DropdownPicker
                          label="تعرفه نماد"
                          onChange={(event) => {
                            setFieldValue("kind", event.target.value);
                          }}
                          list={data.kind}
                          filterable={false}
                          {...onMakeFormikVariable("kind")}
                        />
                      </Grid>
                      
                     <Grid item xs={12} md={12}>
                        <TextField
                          label="توضیحات"
                          type="string"
                          multiline
                          minRows={2}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("description")}
                        />
                      </Grid>  
                      
                      <Grid
                        item
                        xs={12}
                        md={12}
                        container
                        justifyContent={"flex-end"}
                      >
                        <Button
                          disabled={isSubmitting}
                          variant="outlined"
                          size="large"
                          color="gray"
                          sx={{ mx: 1 }}
                          onClick={onNavigateToListPage}
                        >
                          انصراف
                        </Button>

                        <Button
                          disabled={isSubmitting}
                          variant="contained"
                          type="submit"
                          size="large"
                        >
                          {loading && (
                            <CircularProgress size={16} color="inherit" />
                          )}
                          {roleId !== "create" ? "ویرایش" : "ایجاد"}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                );
              }}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default UpdateHistoryModify;
